import { useState } from "react";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { openDialogAction } from "@icarius-common/dialog/actions";
import { executeTableFormAction } from "../actions";
import { getLocalizedString } from "@icarius-localization/strings";

const useProcessExecution = (isTotals, specialProcessParameters, defaultParameter) => {

  const dispatch = useDispatch();

  const [paramsToUse, setParamsToUse] = useState(null);
  const [paramDialogIsOpen, setParamDialogIsOpen] = useState(false);
  const [selectedCodes, setSelectedCodes] = useState(null);

  const handleValidateAndAskProcess = (gridRef) => {
    let selectedRows = gridRef.api.getSelectedRows();

    if (selectedRows.length < 1) {
      dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectAtLeastOneRecord"), severity: "warning" }));
      return;
    }

    const codes = selectedRows.map(item => item['Código de empleado']);
    setSelectedCodes(codes);
    dispatch(openDialogAction({
      title: getLocalizedString("atention"),
      msg: getLocalizedString("areYouSureYouWantToRunTheProcess"),
      onConfirm: () => handleStartExecutionProcess(codes),
      onCancel: () => handleCloseParamDialog(),
    }));
  }

  const handleStartExecutionProcess = (codes) => {
    if (specialProcessParameters?.length) {
      //abrir modal de setparam
      setParamDialogIsOpen(true);
      setParamsToUse(specialProcessParameters);
      return;
    }

    // si no tiene parametros
    executeProcess(null, codes);
  }

  const handleCloseParamDialog = () => {
    setParamDialogIsOpen(false);
    setParamsToUse(null);
    setSelectedCodes(null);
  }

  const executeProcess = (param, codes) => {
    dispatch(executeTableFormAction(
      isTotals,
      {
        codes: selectedCodes || codes,
        parameters: param || defaultParameter,
      }
    ))
      .then(() => {
        handleCloseParamDialog();
      })
  }

  const processExecutionData = {
    paramsToUse,
    paramDialogIsOpen,
  }

  const processExecutionFunctions = {
    handleValidateAndAskProcess,
    executeProcess,
    handleCloseParamDialog,
  }

  return {
    processExecutionData,
    processExecutionFunctions,
  }
}

export default useProcessExecution;
